module.exports = __webpack_public_path__ + "img/head_login_aktiv.510d46e5.png";